import { ForgotPasswordVerifyScreen } from "@/features/auth/screens/ForgotPasswordVerifyScreen";
import { forgotPasswordVerifyRouteSearchSchema } from "@/features/auth/search/authRouteSearch";
import { createFileRoute } from "@tanstack/react-router";

function ForgotPasswordVerifyPage() {
    const { phone, email, type } = Route.useSearch();
    return <ForgotPasswordVerifyScreen phone={phone} email={email} type={type} />;
}

export const Route = createFileRoute("/_auth/forgot-password/verify")({
    component: ForgotPasswordVerifyPage,
    validateSearch: (search) => forgotPasswordVerifyRouteSearchSchema.parse(search),
});
